var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"slide-modal-title"},[_vm._v("Add a new bike")]),_vm._v(" "),_c('AddEditBike',{attrs:{"button-text":"Add Bike"},on:{"submit-bike":_vm.add}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }